export default {
 data() {
  return {
   crmApiPath: '/api/v1/',
   crmApiPathV2: '/api/v2/',
   crmType: process.env.MIX_CRM_TYPE,
   crmCompany: process.env.MIX_CRM_COMPANY,
   crmAppUrl: process.env.MIX_APP_URL
  }
 },
 methods: {
  // convert integer to alpha character (excel column style A -> Z, AA ...)
  numToSSColumn(num){
   let s = '', t;
   while (num > 0) {
    t = (num - 1) % 26;
    s = String.fromCharCode(65 + t) + s;
    num = (num - t)/26 | 0;
   }
   return s || undefined;
  },
  // check if object is empty
  notEmptyObject(someObject) {
   return Object.keys(someObject).length > 0;
  },
  // input and data character manipulation
  forceUppercase(e, o, prop) {
   const start = e.target.selectionStart;
   e.target.value = e.target.value.toUpperCase();
   this.$set(o, prop, e.target.value);
   e.target.setSelectionRange(start, start);
  },
  forceCapitalize(e, o, prop) {
   const start = e.target.selectionStart;
   e.target.value = e.target.value.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.substring(1)).join(' ');
   this.$set(o, prop, e.target.value);
   e.target.setSelectionRange(start, start);
  },
  forceCapitalizeApostrophe(e, o, prop) {
   const start = e.target.selectionStart;
   e.target.value = e.target.value.replace(/\b[a-z]/g, function(letter) { return letter.toUpperCase(); });
   e.target.value = e.target.value.replace(/'(S)/g, function(letter) { return letter.toLowerCase(); });
   this.$set(o, prop, e.target.value);
   e.target.setSelectionRange(start, start);
  },
  /* Format nice address */
  calc_nice_address(building, street, locality, city, county, postcode) {
   if (building == null) {
    building = ""
   }
   if (street == null) {
    street = ""
   }
   if (locality == null) {
    locality = ""
   }
   if (city == null) {
    city = ""
   }
   if (county == null) {
    county = ""
   }
   if (postcode == null) {
    postcode = ""
   }
   
   let nice_address = "";
   
   if (building !== "") {
    nice_address += building
   }
   
   if (nice_address !== "" && street !== "") {
    nice_address += " " + street
   }
   else {
    nice_address += street
   }
   
   if (nice_address !== "" && locality !== "") {
    nice_address += ", " + locality
   }
   else {
    nice_address += locality
   }
   
   if (nice_address !== "" && city !== "") {
    nice_address += ", " + city
   }
   else {
    nice_address += city
   }
   
   if (nice_address !== "" && county !== "") {
    nice_address += ", " + county
   }
   else {
    nice_address += county
   }
   
   if (nice_address !== "" && postcode !== "") {
    nice_address += ", " + postcode
   }
   else {
    nice_address += postcode
   }
   
   if (nice_address === "") {
    return null;
   }
   else {
    return nice_address;
   }
  },
  // scroll to errors on form submit
  formErrorsValidationScroll(form) {
   setTimeout(() => {
    const errors = Object.entries(form.errors)
     .map(([key, value]) => ({key, value}))
     .filter(error => error["value"].length);
    form.refs[errors[0]["key"]].$el.scrollIntoView({
     behavior: "smooth",
     block: "center"
    });
   }, 100);
  },
  // return status of entity test
  checkTest(test) {
   let result = [];
   
   // Using own ltd company
   if (test.using_own_ltd_company === 'Yes') {
    result.push('Pass')
   }
   else if (test.using_own_ltd_company === 'No' || test.using_own_ltd_company === null) {
    result.push('Fail')
   }
   else if (test.using_own_ltd_company === "Don't Know") {
    result.push('Amber')
   }
   // UK Tax Payer
   if (test.uk_tax_payer === 'Yes') {
    result.push('Pass')
   }
   else if (test.uk_tax_payer === 'No' || test.uk_tax_payer === null) {
    result.push('Fail')
   }
   // Send Substitute
   if (test.send_substitution === 'Yes') {
    result.push('Pass')
   }
   else if (test.send_substitution === 'No' || test.send_substitution === null) {
    result.push('Fail')
   }
   else if (test.send_substitution === "Don't Know") {
    result.push('Amber')
   }
   // Substitution Direction Control
   if (test.s_d_c === 'Yes') {
    result.push('Fail')
   }
   else if (test.s_d_c === 'No' || test.s_d_c === null) {
    result.push('Pass')
   }
   // Switch Projects
   if (test.switch_projects === 'Yes') {
    result.push('Fail')
   }
   else if (test.switch_projects === 'No' || test.switch_projects === null) {
    result.push('Pass')
   }
   // On Named Project
   if (test.named_project === 'Yes') {
    result.push('Pass')
   }
   else if (test.named_project === 'No' || test.named_project === null) {
    result.push('Fail')
   }
   else if (test.named_project === "Don't Know") {
    result.push('Amber')
   }
   // Decide how work performed
   if (test.how_work_performed === 'Yes') {
    result.push('Pass')
   }
   else if (test.how_work_performed === 'No' || test.how_work_performed === null) {
    result.push('Fail')
   }
   // Decide working hours
   if (test.decide_working_hours === 'Yes' || test.decide_working_hours === null) {
    result.push('Fail')
   }
   else if (test.decide_working_hours === 'No' || test.decide_working_hours === "Not applicable") {
    result.push('Pass')
   }
   else if (test.decide_working_hours === "Partly") {
    result.push('Amber')
   }
   // Notice Period
   if (test.notice_period === 'No Notice') {
    result.push('Pass')
   }
   else if (test.notice_period === '7 Days' || test.notice_period === "Longer" || test.notice_period === null) {
    result.push('Fail')
   }
   // Offer other work
   if (test.offer_other_work === 'Yes' || test.offer_other_work === null) {
    result.push('Fail')
   }
   else if (test.offer_other_work === 'No') {
    result.push('Pass')
   }
   else if (test.offer_other_work === "Don't Know") {
    result.push('Amber')
   }
   // Correct errors
   if (test.correct_errors === 'Yes') {
    result.push('Pass')
   }
   else if (test.correct_errors === 'No' || test.correct_errors === null) {
    result.push('Fail')
   }
   else if (test.correct_errors === "Don't Know") {
    result.push('Amber')
   }
   // Last permanent employer
   if (test.last_permanent_employer === 'Yes' || test.last_permanent_employer === null) {
    result.push('Fail')
   }
   else if (test.last_permanent_employer === 'No') {
    result.push('Pass')
   }
   // Sick pay
   if (test.sick_pay === 'Yes' || test.sick_pay === null) {
    result.push('Fail')
   }
   else if (test.sick_pay === 'No') {
    result.push('Pass')
   }
   // Holiday entitlement
   if (test.holiday_entitlement === 'Yes' || test.holiday_entitlement === null) {
    result.push('Fail')
   }
   else if (test.holiday_entitlement === 'No') {
    result.push('Pass')
   }
   // Work Place Pension
   if (test.work_place_pension === 'Yes' || test.work_place_pension === null) {
    result.push('Fail')
   }
   else if (test.work_place_pension === 'No') {
    result.push('Pass')
   }
   // Maternity / Paternity
   if (test.maternity_paternity === 'Yes' || test.maternity_paternity === null) {
    result.push('Fail')
   }
   else if (test.maternity_paternity === 'No') {
    result.push('Pass')
   }
   // Paid Training
   if (test.paid_training === 'Yes' || test.paid_training === null) {
    result.push('Fail')
   }
   else if (test.paid_training === 'No') {
    result.push('Pass')
   }
   // Restrict other work
   if (test.restrict_other_work === 'Yes' || test.restrict_other_work === null) {
    result.push('Fail')
   }
   else if (test.restrict_other_work === 'No') {
    result.push('Pass')
   }
   // Own money on training
   if (test.own_money_on_training === 'Yes') {
    result.push('Pass')
   }
   else if (test.own_money_on_training === 'No' || test.own_money_on_training === null) {
    result.push('Fail')
   }
   // Provide own equipment
   if (test.provide_own_equipment === 'Yes') {
    result.push('Pass')
   }
   else if (test.provide_own_equipment === 'No') {
    result.push('Amber')
   }
   else if (test.provide_own_equipment === null) {
    result.push('Fail')
   }
   if (result.includes('Fail')) {
    return "Fail"
   }
   else if (result.includes('Amber')) {
    return "Amber"
   }
   else {
    return "Pass"
   }
  },
  // Sort array of objects based on another array
  mapArrayOrder(array, order, key) {
   array.sort(function (a, b) {
    let A = a[key], B = b[key];
    if (order.indexOf(A) > order.indexOf(B)) {
     return 1;
    }
    else {
     return -1;
    }
   });
   return array;
  },
  // Set Google Address Fields
  set_google_address(place) {
   let building = null, street = null, locality = null, city_town = null, county = null, postcode = null;
 
   for (let i = 0; i < place.address_components.length; i++) {
    //get place component type
    let addressType = place.address_components[i].types[0];
  
    // Depending on place address_component append or set relevant address part
    switch (addressType) {
     case "subpremise":
      building = place.address_components[i].long_name;
      break;
     case "premise":
      if (building !== null) {
       building += " " + place.address_components[i].long_name;
      }
      else {
       building = place.address_components[i].long_name;
      }
      break;
     case "street_number":
      street = place.address_components[i].long_name;
      break;
     case "route":
      if (street !== null) {
       street += " " + place.address_components[i].long_name;
      }
      else {
       street = place.address_components[i].long_name;
      }
      break;
     case "locality":
      locality = place.address_components[i].long_name;
      break;
     case "postal_town":
      city_town = place.address_components[i].long_name;
      break;
     case "administrative_area_level_2":
      county = place.address_components[i].long_name;
      break;
     case "postal_code":
      postcode = place.address_components[i].long_name;
      break;
    }
   }
   return {
    building: building,
    street: street,
    locality: locality,
    city_town: city_town,
    county: county,
    postcode: postcode
   }
  },
  // return file path for clients timesheet template example file
  file_path_client_timesheet_template_example_file(timesheet_template_name) {
   switch (timesheet_template_name) {
    case 'WOODHART_GROUP_CARPENTRY_TEMPLATE':
     return this.crmAppUrl + '/timesheet_templates/WOODHART_GROUP_CARPENTRY_TEMPLATE.xlsx'
   }
  }
 }
}
